import React from "react";

import styles from "./plus.module.scss";

type FiltrePlusProps = {
    children: React.ReactNode;
};

const FiltrePlus = ({ children }: FiltrePlusProps) => {
    return (
        <div data-component="FiltrePlus" className={styles.filtre}>
            <div className={styles.listeFiltreContainer}>{children}</div>
        </div>
    );
};

export default FiltrePlus;
